import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import useReveal from "@/hooks/useReveal";

const contactEmail = "workwithdilip1@gmail.com";

const rights = [
    ["Access", "Ask for a copy of personal data associated with your account or waitlist submission."],
    ["Correction", "Ask us to correct inaccurate or incomplete profile, waitlist, or account information."],
    ["Deletion", "Ask us to delete personal data where applicable, subject to safety, fraud, legal, or technical retention limits."],
    ["Portability", "Request a portable copy of data you provided, where technically feasible."],
    ["Objection", "Object to certain processing activities, including some forms of analytics or marketing."],
    ["Restriction", "Ask us to limit processing while a request, objection, or dispute is being reviewed."],
];

const bases = [
    "Consent for waitlist communications, optional marketing, and some preference-based features.",
    "Contract or pre-contract steps for account access, matching, safety controls, and support.",
    "Legitimate interests for fraud prevention, product security, abuse detection, and aggregate product improvement.",
    "Legal obligations where applicable laws require records, responses, or safety action.",
];

export default function Gdpr() {
    useReveal();

    return (
        <div className="relative min-h-screen overflow-x-hidden" data-testid="gdpr-page">
            <div className="grain" />
            <Header />
            <main id="top">
                <section className="relative pt-36 pb-20 lg:pt-44 lg:pb-28">
                    <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
                        <div className="reveal in font-mono text-[10px] uppercase tracking-[0.3em] text-[var(--hot)] mb-8">
                            GDPR edition · data rights
                        </div>
                        <h1 className="reveal in font-display text-[17vw] sm:text-[12vw] lg:text-[10rem] leading-[0.82] tracking-tighter">
                            Your data has{" "}
                            <span className="font-italic-serif text-[var(--hot)]">
                                rights.
                            </span>
                        </h1>
                        <p className="reveal in mt-8 max-w-2xl text-lg leading-relaxed text-[var(--ink-soft)]">
                            This page summarizes how European privacy rights should
                            work for LÜVYN users and waitlist members.
                        </p>
                    </div>
                </section>

                <section className="relative py-20 lg:py-28 bg-[var(--paper-2)] border-y-2 border-[var(--ink)]">
                    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                        <div className="reveal grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                            {rights.map(([title, copy], index) => (
                                <article
                                    key={title}
                                    className="bg-[var(--paper)] border-2 border-[var(--ink)] p-7 min-h-[220px]"
                                >
                                    <div className="font-display text-5xl text-[var(--hot)]">
                                        {String(index + 1).padStart(2, "0")}
                                    </div>
                                    <h2 className="mt-8 font-display text-3xl leading-tight">
                                        {title}
                                    </h2>
                                    <p className="mt-4 text-sm leading-relaxed text-[var(--ink-soft)]">
                                        {copy}
                                    </p>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="relative py-20 lg:py-28">
                    <div className="max-w-[1100px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-12">
                        <div className="reveal">
                            <div className="stamp mb-6">Legal bases</div>
                            <h2 className="font-display text-6xl lg:text-8xl leading-[0.86] tracking-tighter">
                                Why data is{" "}
                                <span className="font-italic-serif text-[var(--hot)]">
                                    processed.
                                </span>
                            </h2>
                        </div>
                        <div className="reveal border-y-2 border-[var(--ink)]">
                            {bases.map((base) => (
                                <p key={base} className="py-6 border-b-2 border-[var(--ink)] last:border-b-0 leading-relaxed text-[var(--ink-soft)]">
                                    {base}
                                </p>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="relative py-16 bg-[var(--ink)] text-[var(--paper)]">
                    <div className="max-w-[1100px] mx-auto px-6 lg:px-10">
                        <p className="reveal font-display text-4xl lg:text-6xl leading-tight">
                            To make a GDPR request, email{" "}
                            <a className="text-[var(--hot)]" href={`mailto:${contactEmail}`}>
                                {contactEmail}
                            </a>
                            .
                        </p>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
